import { useState, useEffect } from "react";
import { subirDatos } from "./syncSupabase";
import { STORAGE_CUENTAS } from "./FinanzasConfig";

const STORAGE_CAJA = 'alqos_movimientos_caja';
const STORAGE_CXC = 'alqos_cxc_cxp';

function hoy() { return new Date().toISOString().slice(0, 10); }

const TIPOS = {
  ingreso:      { label: 'Ingreso',      color: '#16a34a', icono: '⬆️' },
  egreso:       { label: 'Egreso',       color: '#dc2626', icono: '⬇️' },
  transferencia:{ label: 'Transferencia',color: '#2A7FFF', icono: '🔁' },
};

const FORM_VACIO = { tipo: 'ingreso', cuentaId: '', cuentaDestinoId: '', monto: '', concepto: '', fecha: hoy(), cxcCxpId: '' };

export default function MovimientosCaja({ onVolver, oscuro, usuario }) {
  const [movimientos, setMovimientos] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [cxcItems, setCxcItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(FORM_VACIO);
  const [filtroCuenta, setFiltroCuenta] = useState('todas');
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    (async () => {
      try { setMovimientos(JSON.parse(localStorage.getItem(STORAGE_CAJA) || '[]')); } catch {}
      try { setCuentas(JSON.parse(localStorage.getItem(STORAGE_CUENTAS) || '[]')); } catch {}
      try { setCxcItems(JSON.parse(localStorage.getItem(STORAGE_CXC) || '[]')); } catch {}
      setCargando(false);
    })();
    const onSync = () => {
      try { setMovimientos(JSON.parse(localStorage.getItem(STORAGE_CAJA) || '[]')); } catch {}
      try { setCuentas(JSON.parse(localStorage.getItem(STORAGE_CUENTAS) || '[]')); } catch {}
      try { setCxcItems(JSON.parse(localStorage.getItem(STORAGE_CXC) || '[]')); } catch {}
    };
    window.addEventListener('supabase-sync-complete', onSync);
    return () => window.removeEventListener('supabase-sync-complete', onSync);
  }, []);

  const guardarMovimientos = (lista) => {
    setMovimientos(lista);
    localStorage.setItem(STORAGE_CAJA, JSON.stringify(lista));
    subirDatos(STORAGE_CAJA);
  };
  const guardarCuentas = (lista) => {
    setCuentas(lista);
    localStorage.setItem(STORAGE_CUENTAS, JSON.stringify(lista));
    subirDatos(STORAGE_CUENTAS);
  };

  const cuentasCaja = cuentas.filter(c => c.activo !== false && c.codigo?.startsWith('1.1.01'));
  const cxcAbiertas = cxcItems.filter(i => i.estado !== 'pagado');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const abrirNuevo = () => { setForm(FORM_VACIO); setShowForm(true); };

  const guardar = () => {
    const monto = Number(form.monto || 0);
    if (monto <= 0) return alert('El monto debe ser mayor a 0');
    if (!form.cuentaId) return alert('Seleccioná la cuenta');
    if (form.tipo === 'transferencia' && (!form.cuentaDestinoId || form.cuentaDestinoId === form.cuentaId)) {
      return alert('Seleccioná una cuenta destino distinta de la de origen');
    }

    const nuevo = {
      id: Math.floor(Date.now()),
      tipo: form.tipo,
      cuentaId: Number(form.cuentaId),
      cuentaDestinoId: form.tipo === 'transferencia' ? Number(form.cuentaDestinoId) : null,
      monto,
      concepto: form.concepto,
      cxcCxpId: form.cxcCxpId ? Number(form.cxcCxpId) : null,
      asientoId: null,
      fecha: form.fecha,
      createdBy: usuario?.nombre || 'Sistema',
      createdAt: new Date().toISOString(),
    };
    guardarMovimientos([nuevo, ...movimientos]);

    let cuentasActualizadas = cuentas;
    if (form.tipo === 'ingreso') {
      cuentasActualizadas = cuentas.map(c => c.id === nuevo.cuentaId ? { ...c, saldo: Number((c.saldo || 0) + monto) } : c);
    } else if (form.tipo === 'egreso') {
      cuentasActualizadas = cuentas.map(c => c.id === nuevo.cuentaId ? { ...c, saldo: Number((c.saldo || 0) - monto) } : c);
    } else if (form.tipo === 'transferencia') {
      cuentasActualizadas = cuentas.map(c => {
        if (c.id === nuevo.cuentaId) return { ...c, saldo: Number((c.saldo || 0) - monto) };
        if (c.id === nuevo.cuentaDestinoId) return { ...c, saldo: Number((c.saldo || 0) + monto) };
        return c;
      });
    }
    guardarCuentas(cuentasActualizadas);

    setShowForm(false);
  };

  const visibles = movimientos
    .filter(m => filtroCuenta === 'todas' || m.cuentaId === Number(filtroCuenta) || m.cuentaDestinoId === Number(filtroCuenta))
    .filter(m => filtroTipo === 'todos' || m.tipo === filtroTipo);

  const nombreCuenta = (id) => { const c = cuentas.find(c => c.id === id); return c ? `${c.codigo} — ${c.nombre}` : '—'; };
  const nombreCxc = (id) => { const i = cxcItems.find(i => i.id === id); return i ? `${i.entidadNombre} (${i.documentoOrigen || 's/doc'})` : null; };

  const inp = { width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #E5E7EB', fontSize: '13px', boxSizing: 'border-box', fontFamily: 'Inter, sans-serif' };
  const lbl = { fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '4px', display: 'block' };

  if (cargando) return <div style={{ padding: '40px', textAlign: 'center', color: '#9CA3AF' }}>Cargando movimientos…</div>;

  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, sans-serif', background: '#E8E9F6', minHeight: '100vh' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button onClick={onVolver} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', color: '#6B7280' }}>← Menú</button>
          <span style={{ fontSize: '22px' }}>🏦</span>
          <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>Movimientos de Caja</h1>
        </div>
        <button onClick={abrirNuevo} style={{ background: '#1C3FAA', color: 'white', border: 'none', borderRadius: '10px', padding: '10px 18px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>+ Nuevo movimiento</button>
      </div>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
        <select style={{ ...inp, maxWidth: '220px' }} value={filtroCuenta} onChange={e => setFiltroCuenta(e.target.value)}>
          <option value="todas">Todas las cuentas</option>
          {cuentasCaja.map(c => <option key={c.id} value={c.id}>{c.codigo} — {c.nombre}</option>)}
        </select>
        <select style={{ ...inp, maxWidth: '160px' }} value={filtroTipo} onChange={e => setFiltroTipo(e.target.value)}>
          <option value="todos">Todos los tipos</option>
          {Object.entries(TIPOS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>

      <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#F9FAFB' }}>
              {['Fecha', 'Tipo', 'Cuenta', 'Monto', 'Concepto', 'Vinculación'].map(h => (
                <th key={h} style={{ padding: '10px 14px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textAlign: 'left', borderBottom: '1px solid #E5E7EB' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibles.length === 0 ? (
              <tr><td colSpan={6} style={{ padding: '60px', textAlign: 'center', color: '#9CA3AF' }}>Sin movimientos cargados</td></tr>
            ) : visibles.map(m => (
              <tr key={m.id}>
                <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px' }}>{m.fecha}</td>
                <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }}>
                  <span style={{ background: `${TIPOS[m.tipo]?.color}18`, color: TIPOS[m.tipo]?.color, fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>{TIPOS[m.tipo]?.icono} {TIPOS[m.tipo]?.label}</span>
                </td>
                <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px' }}>
                  {nombreCuenta(m.cuentaId)}{m.tipo === 'transferencia' && ` → ${nombreCuenta(m.cuentaDestinoId)}`}
                </td>
                <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px', fontWeight: '600' }}>${Number(m.monto).toLocaleString('es-AR')}</td>
                <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '13px' }}>{m.concepto || '—'}</td>
                <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px', color: '#6B7280' }}>{nombreCxc(m.cxcCxpId) || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '460px', padding: '24px' }}>
            <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#1C3FAA', margin: '0 0 16px' }}>+ Nuevo movimiento</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <label style={lbl}>Tipo</label>
                <select style={inp} value={form.tipo} onChange={e => set('tipo', e.target.value)}>
                  {Object.entries(TIPOS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>{form.tipo === 'transferencia' ? 'Cuenta origen' : 'Cuenta'} *</label>
                <select style={inp} value={form.cuentaId} onChange={e => set('cuentaId', e.target.value)}>
                  <option value="">— Seleccionar —</option>
                  {cuentasCaja.map(c => <option key={c.id} value={c.id}>{c.codigo} — {c.nombre}</option>)}
                </select>
              </div>
              {form.tipo === 'transferencia' && (
                <div>
                  <label style={lbl}>Cuenta destino *</label>
                  <select style={inp} value={form.cuentaDestinoId} onChange={e => set('cuentaDestinoId', e.target.value)}>
                    <option value="">— Seleccionar —</option>
                    {cuentasCaja.map(c => <option key={c.id} value={c.id}>{c.codigo} — {c.nombre}</option>)}
                  </select>
                </div>
              )}
              <div>
                <label style={lbl}>Monto *</label>
                <input style={inp} type="number" value={form.monto} onChange={e => set('monto', e.target.value)} />
              </div>
              <div>
                <label style={lbl}>Concepto</label>
                <input style={inp} value={form.concepto} onChange={e => set('concepto', e.target.value)} />
              </div>
              <div>
                <label style={lbl}>Fecha</label>
                <input style={inp} type="date" value={form.fecha} onChange={e => set('fecha', e.target.value)} />
              </div>
              {form.tipo !== 'transferencia' && (
                <div>
                  <label style={lbl}>Vincular con CxC/CxP (opcional)</label>
                  <select style={inp} value={form.cxcCxpId} onChange={e => set('cxcCxpId', e.target.value)}>
                    <option value="">— Ninguna —</option>
                    {cxcAbiertas.map(i => <option key={i.id} value={i.id}>{i.entidadNombre} — {i.documentoOrigen || 's/doc'} (${Number(i.montoPendiente).toLocaleString('es-AR')})</option>)}
                  </select>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setShowForm(false)} style={{ flex: 1, padding: '10px', borderRadius: '10px', border: '1px solid #E5E7EB', background: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: '#6B7280' }}>Cancelar</button>
              <button onClick={guardar} style={{ flex: 2, padding: '10px', borderRadius: '10px', border: 'none', background: '#1C3FAA', color: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
